import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const invitationApi = createApi({
  reducerPath: "invitationApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  }),
  endpoints: (builder) => ({
    validateInvitation: builder.query({
      query: (token) => ({
        url: "invitations/validate",
        params: { token },
      }),
    }),
  }),
});

export const {
  useValidateInvitationQuery,
  useLazyValidateInvitationQuery,
} = invitationApi;
